import type { CsfDataViewDto } from '@subscriptions/application/dtos';
import type { CsfDataApiResponse } from '@subscriptions/infrastructure/api/types';

export type CsfApiMapperType = {
  mapApiResponseToDto: (response: CsfDataApiResponse) => CsfDataViewDto;
};

/**
 * Creates the mapper for CSF extraction responses.
 *
 * Only the fields the invoice form can use are carried over; the address parts the document
 * also returns have no field to land on.
 */
export const createCsfApiMapper = (): CsfApiMapperType => {
  /**
   * Maps CSF API response to view DTO.
   * Only fields that can be used in the invoice form are included.
   *
   * @param response - API response containing extracted CSF data
   * @returns View DTO with form-compatible fields
   */
  const mapApiResponseToDto = (response: CsfDataApiResponse): CsfDataViewDto => ({
    rfc: response.rfc ?? '',
    businessName: response.businessName ?? '',
    taxRegimeDescription: response.taxRegime ?? '',
    postalCode: response.zipCode ?? '',
    firstLastName: response.paternalLastName ?? '',
    secondLastName: response.maternalLastName ?? '',
  });

  return { mapApiResponseToDto };
};
